// 共通 apiConfig.ts（admin / customer / developer 全てで使用）

const getBaseURL = (): string => {
  // ✔ ローカル開発時
  if (process.env.NODE_ENV === 'development') {
    // server: localhost:3001 で起動している前提
    return 'http://localhost:3001';
  }

  // ✔ ビルド時に環境変数が指定されていればそれを優先
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // ✔ Cloud Run (stg / prod) のホスト名で判定する
  const host = window.location.hostname;

  // ---- ステージング環境 ----
  if (
    host.includes('camiyui-admin-stg') ||
    host.includes('camiyui-customer-stg') ||
    host.includes('camiyui-dev-stg')
  ) {
    return 'https://camiyui-api-stg-345876359062.asia-southeast1.run.app';
  }

  // ---- 本番環境 ----
  if (
    host.includes('camiyui-admin-prod') ||
    host.includes('camiyui-customer-prod') ||
    host.includes('camiyui-dev-prod')
  ) {
    return 'https://camiyui-api-prod-345876359062.asia-southeast1.run.app';
  }

  // 想定外パターン
  // （ローカルでもなく、環境変数もなく、ホスト名でも判定できない）
  // eslint-disable-next-line no-console
  console.warn('API baseURL を自動判定できませんでした。host =', host);
  return '';
};

const baseURL = getBaseURL();

if (!baseURL) {
  // eslint-disable-next-line no-console
  console.warn('API baseURL が設定されていません（本番ビルド）。');
}

const apiConfig = { baseURL };
export default apiConfig;
